/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Inbound_Waiting_On_WarehouseInputs */

const en_inbound_waiting_on_warehouse = /** @type {(inputs: Inbound_Waiting_On_WarehouseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on the warehouse · ASN · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on the warehouse · ASN · since {since}" |
*
* @param {Inbound_Waiting_On_WarehouseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_warehouse = /** @type {((inputs: Inbound_Waiting_On_WarehouseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_WarehouseInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_warehouse(inputs)
});